import { type ReduxStateShared } from '~shared/types';

export default (state: ReduxStateShared) => state.checkout.checkout;
export const getEditOrder = (state: ReduxStateShared) => state.checkout.editOrder;
export const getEditShipmentID = (state: ReduxStateShared) => state.checkout.editOrderShipmentID;
/**
 * @deprecated use useCartData hook instead
 */
export const getAutoRefills__DEPRECATED = (state: ReduxStateShared) => state.checkout.autoRefills;
export const getShowingValidationErrors = (state: ReduxStateShared) => state.checkout.showingValidationErrors;
export const getPaymentAmount = (state: ReduxStateShared) => state.checkout.checkout.payment_method_amount;
export const getSecondPaymentAmount = (state: ReduxStateShared) => state.checkout.checkout.second_payment_method_amount;
export const getEditPaymentAmount = (state: ReduxStateShared) => state.checkout.editOrder.payment_method_amount;
export const getEditSecondPaymentAmount = (state: ReduxStateShared) =>
  state.checkout.editOrder.second_payment_method_amount;
export const getWindows = (state: ReduxStateShared) => state.checkout.deliveryWindows;
export const getHasScheduleableDeliveryFeesInCart = (state: ReduxStateShared) =>
  state.checkout.hasScheduleableDeliveryFeesInCart;
